@if (block.data.header) {
    <h2 class="underline" [innerText]="block.data.header"></h2>
}

<div class="custom-cards" [ngClass]="getCardColumnsClass()">
    @for (action of block.content; track trackByFn($index, action)) {
        @if (action.data.includeCTA) {
            <div class="custom-card custom-card--with-cta">
                <ng-container *ngTemplateOutlet="cardContents; context: { item: action }"></ng-container>
                @if (action.data.linkUrl && action.data.linkText) {
                    <div class="custom-card__cta">
                        @if (!action.data.externalLink) {
                            <a
                                [ngClass]="['btn', 'mb-0', 'btn-' + (action.data.btnColor || 'primary')]"
                                [routerLink]="routerLinkUrl(action.data.linkUrl)"
                                [fragment]="routerLinkFragment(action.data.linkUrl)">
                                {{ action.data.linkText }}
                            </a>
                        } @else {
                            <a
                                [ngClass]="['btn', 'mb-0', 'btn-' + (action.data.btnColor || 'primary')]"
                                [href]="action.data.linkUrl"
                                target="_blank"
                                rel="noopener">
                                {{ action.data.linkText }}
                            </a>
                        }
                    </div>
                }
            </div>
        } @else {
            @if (action.data.url) {
                @if (action.data.internalLink) {
                    <a
                        [routerLink]="routerLinkUrl(action.data.url)"
                        [fragment]="routerLinkFragment(action.data.url)"
                        class="custom-card">
                        <ng-container *ngTemplateOutlet="cardContents; context: { item: action }"></ng-container>
                    </a>
                } @else {
                    <a [href]="action.data.url" target="_blank" class="custom-card">
                        <ng-container *ngTemplateOutlet="cardContents; context: { item: action }"></ng-container>
                    </a>
                }
            } @else {
                <div class="custom-card">
                    <ng-container *ngTemplateOutlet="cardContents; context: { item: action }"></ng-container>
                </div>
            }
        }
    }
</div>

<ng-template #cardContents let-item="item">
    @if (item.data.image) {
        <img class="custom-card__image" [src]="item.data.image" [alt]="item.data.alt_text" />
    }
    <div class="custom-card__text">
        @if (item.data.title) {
            <h3 [innerText]="item.data.title"></h3>
        }
        @if (item.data.text) {
            <div [innerHtml]="item.data.text"></div>
        }
    </div>
    @if (item.data.url) {
        <div class="custom-card__icon">
            <core-icon name="icon-arrow-circle" [size]="24" color="var(--link-text, var(--color-primary))"></core-icon>
        </div>
    }
</ng-template>
